export function formatDate(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return "";
  }
}

export function fileTypeLabel(t) {
  if (!t) return "FILE";
  const x = String(t).toLowerCase();
  if (x === "url") return "LINK";
  return x.toUpperCase();
}

export function fileTypeIcon(t) {
  const x = String(t || "").toLowerCase();
  if (["pdf"].includes(x)) return "file-text";
  if (["ppt", "pptx"].includes(x)) return "presentation";
  if (["doc", "docx"].includes(x)) return "file-text";
  if (["jpg", "jpeg", "png", "webp"].includes(x)) return "image";
  if (["mp4", "mov"].includes(x)) return "video";
  if (x === "url") return "link";
  return "file";
}
